import http from '@/lib/http'
import { apiPrefix } from './apiPrefix'

export default {
  // 权益合作商列表
  getEquityPartnerList(params) {
    return http.get(`${apiPrefix}/v2/get/coopartner/list`, { params })
  },

  // 赛季过场弹窗是否弹出
  isShowLevelEquityPopup(params) {
    return http.get(`${apiPrefix}/v2/get/cooperate/popup/window`, { params })
  },

  // 上一赛季回顾
  getPrevSeasonInfo(params) {
    return http.get(`${apiPrefix}/v2/get/last/season/review`, { params })
  },

  // 当前赛季等级
  getCurrentSeasonInfo(params) {
    return http.get(`${apiPrefix}/v2/get/current/season/review`, { params })
  },
}
